(function () {
    'use strict';

    angular
        .module('planInitiativeEditModule')
        .controller('InitiativeAddController', Controller);

    Controller.$inject = ['$scope', '$state', '$location', 'historyCtxtService', 'initiative'];

    function Controller($scope, $state, $location, historyCtxtService, initiative) {
        $scope.initiative = initiative;
        $scope.hasHistoryContext = historyCtxtService.hasContext();

        $scope.goToSearchResults = function () {
            $state.go('newPlanInitiativeSearch');
        };

        $scope.goToManageInitiatives = function () {
            $state.go('newPlanInitiativeSearch', {
                facets: '-creationStatusValue=ReadyForTracking'
            });
        };

        $scope.goToPlanInitiative = function () {
            $state.go('initiative.edit');
        };
    }
})();